import React, { useState, useEffect } from 'react';
import AlertEvaluationResults from './AlertEvaluationResults.js';
import AlertConfiguration from './AlertConfiguration.js';
import AlertSettings from './AlertSettings.js';
import StockChart from '../stock/StockChart.js';
import AlertDataSample from './AlertDataSample.js';
import QuoteDateAnalysis from './QuoteDateAnalysis.js';
import { Link } from 'react-router-dom'
import AlertProfitChart from "./AlertProfitChart.js"
import AlertTradeResultsChart from './AlertTradeResultsChart.js';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ActionResult from '../components/ActionResult.js'
import CreateAlgoModal from './CreateAlgoModal.js';
import AlertPerformanceHistory from './AlertPerformanceHistory.js';
import ParameterSensitivityChart from './ParameterSensitivityChart.js';

function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

function AlertSandbox(props) {

    const [config, setConfig] = useState({})
    const [maxConfig, setMaxConfig] = useState({})
    const [defaultConfig, setDefaultConfig] = useState({})
    const [performance, setPerformance] = useState({})
    const [performanceArray, setPerformanceArray] = useState([])
    const [rangeParameter, setRangeParameter] = useState(null);
    const [symbol, setSymbol] = useState(null)
    const [timeframe, setTimeframe] = useState(0)
    const [updates, setUpdates] = useState(0);
    const [selectedStrategyId, setSelectedStrategyId] = useState(0);
    const [startDate, setStartDate] = useState(new Date(2014, 0, 1));
    const [endDate, setEndDate] = useState(new Date());
    const [addRandomness, setAddRandomness] = useState(false);
    const [showDrawdown, setShowDrawdown] = useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [createAlgoModalOpen, setCreateAlgoModalOpen] = React.useState(false);
    const [algoName, setAlgoName] = React.useState(null);
    const [result, setResult] = useState(null);
    const [isShort, setIsShort] = useState(false);

    useEffect(() => {
        (async function () {

            if (selectedStrategyId) {
                console.log("Loading default config", selectedStrategyId);
                setSelectedStrategyId(selectedStrategyId);

                let text = await (await fetch(`/api/strategyDefaultConfig?strategyId=` + selectedStrategyId)).json();
                if (text && text.config) {
                    setConfig(text.config);
                    setDefaultConfig(text.config);
                    setIsShort(text.isShort === 1 || text.isShort === true);
                }
            }
        })();
    }, [selectedStrategyId, updates]);

    async function handleReset() {
        setUpdates(updates + 1);
    }

    async function handleEvaluate(conf = null, start = null, end = null, arrayIndex = null) {
        if (selectedStrategyId && symbol) {

            console.log("addRandomness", addRandomness);

            let startToUse = start ? start : startDate;
            let endToUse = end ? end : endDate;
            let url = "/api/strategySandboxEvaluator?strategyId=" + selectedStrategyId + "&symbol=" + symbol + "&timeframe=" + timeframe
            if (startDate) url += "&startDate=" + startToUse.getFullYear().toString() + "-" + (startToUse.getMonth() + 1).toString() + "-" + (startToUse.getDate()).toString();
            if (endDate) url += "&endDate=" + endToUse.getFullYear().toString() + "-" + (endToUse.getMonth() + 1).toString() + "-" + (endToUse.getDate()).toString();
            url += "&addRandomness=" + (addRandomness ? 'true' : 'false');
            const configToUse = conf ? JSON.stringify(conf) : JSON.stringify(config)
            console.log("handleEvaluate", configToUse);
            console.log("handleEvaluate", url);

            const r = await (await fetch(url, {
                method: 'POST',
                body: configToUse
            })).json();
            console.log(r);
            setPerformance(r);
            
            if (arrayIndex !== null) {
                setPerformanceArray(prevArray => [...prevArray, { id: arrayIndex, ...r, config: conf }]);
            } else {
                setPerformanceArray([]);
            }
        }
    }

    function handleClearResults() {
    }

    async function testRange(configToTest, key, start, end, startCounter) {
        let counter = 0;
        for (let j = start; j <= end; isInt(start) ? j++ : j = j + .1) {
            let tempConfig = JSON.parse(JSON.stringify(configToTest));
            tempConfig[key] = j;
            let finalCounter = startCounter + counter;

            setTimeout(async (c) => {
                handleEvaluate(c, null, null, Math.round(finalCounter));
            }, 100 * counter, tempConfig);

            ++counter;
        }
        return counter;
    }

    async function handleEvaluateRange() {
        setPerformanceArray([]);
        let ObjectKeys = Object.keys(maxConfig);
        let counter = 0;

        if (ObjectKeys.length === 1) {
            let key = ObjectKeys[0];
            setRangeParameter(key);
            let start = Number(config[key]);
            let end = Number(maxConfig[key]);
            await testRange(config, key, start, end, counter);
        } else if (ObjectKeys.length > 1) {
            let primaryKey = ObjectKeys[0];
            let secondaryKey = ObjectKeys[1];
            setRangeParameter(secondaryKey);

            let start = Number(config[primaryKey]);
            let end = Number(maxConfig[primaryKey]);

            let secondaryStart = Number(config[secondaryKey]);
            let secondaryEnd = Number(maxConfig[secondaryKey]);

            for (let i = start; i <= end; isInt(start) ? i++ : i = i + .1) {
                let tempConfig = JSON.parse(JSON.stringify(config));
                tempConfig[primaryKey] = i;

                let iterations = await testRange(tempConfig, secondaryKey, secondaryStart, secondaryEnd, counter);
                counter += iterations;
            }
        }
    }

    function handleConfigUpdate(c) {
        console.log(c);
        setConfig(c);
        handleEvaluate(c);
    }

    function handleAlertUpdated(strategyId, symbol, timeframe, name) {
        console.log(strategyId, symbol, timeframe, name);
        setSelectedStrategyId(strategyId);
        setSymbol(symbol);
        setTimeframe(timeframe);
    }

    function onDataSampleUpdated(startDate, endDate) {
        setStartDate(startDate);
        setEndDate(endDate);
        handleEvaluate(null, startDate, endDate);
    }

    function onAddRandomnessUpdated(shouldAddRandomness) {
        setAddRandomness(shouldAddRandomness);
    }

    const handleCloseModal = () => {
        setModalOpen(false);
    }
    const handleOpenModal = () => {
        setModalOpen(true);
    }

    function openCreateAlgoModal() {
        setCreateAlgoModalOpen(true);
    }

    function handleCreateAlgoClosed(result) {
        setCreateAlgoModalOpen(false);
        if (result)
            setResult(result);
    }

    function shouldAllowEdits() {
        if (props.role === 3) return true;
        else return false;
    }

    async function handleCreateAlert() {
        const url = "/api/strategyAlertCreate?strategyId=" + selectedStrategyId + "&symbol=" + symbol + "&timeframe=" + timeframe + "&algo=" + algoName;
        console.log(url);
        const r = await (await fetch(url, { method: 'POST' })).json();
        if (r.success && r.id) {
            const updateConfigUrl = "/api/strategyAlertUpdate?alertId=" + r.id
            console.log(updateConfigUrl);
            await (await fetch(updateConfigUrl, {
                method: 'POST',
                body: JSON.stringify(config)
            })).json();
            setResult({ success: "Alert created" })
        } else {
            setResult({ error: "Could not create alert" })
        }

        handleCloseModal();
    }

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    function getTrades() {
        if (performance && performance.trades && performance.trades.length) {
            return performance.trades.map(t => {
                return {
                    purchase_date: t.purchaseDate,
                    purchase_price: t.purchasePrice,
                    sell_date: t.sellDate,
                    sell_price: t.sellPrice,
                    profitPercentage: t.profitPercentage
                }
            })
        } else {
            return [];
        }
    }

    return (
        <div>
            <table width="500px">
                <AlertSettings onAlertUpdated={handleAlertUpdated} hideAlgoName={true} /><br></br>
            </table>

            {selectedStrategyId && symbol ?
                <>

                    <table width="100%" cellPadding={10}>
                        <tr valign='bottom'>
                            <td>
                                <AlertConfiguration config={config} maxConfig={maxConfig} defaultConfig={defaultConfig} onConfigUpdated={handleConfigUpdate} onMaxConfigUpdated={setMaxConfig} onEvaluateRange={handleEvaluateRange} showMaxConfig={!props.mobileView} />
                            </td>
                            <td align='left' width="250px">
                                <AlertEvaluationResults mobileView={props.mobileView} performance={performance} performanceArray={performanceArray} shouldShowTrades={!props.mobileView} />
                            </td>
                            <td align='left' >
                                <Link onClick={() => setShowDrawdown(!showDrawdown)}>{showDrawdown ? "Show Profit" : "Show Drawdown"}</Link>
                                <StockChart symbol={symbol} trades={getTrades()} />
                                <AlertProfitChart isShort={isShort} symbol={symbol} showDrawdown={showDrawdown} performance={performance} startDate={new Date(startDate)} endDate={new Date(endDate)} />
                            </td>
                        </tr>
                    </table>

                    <AlertDataSample onDataSampleUpdated={onDataSampleUpdated} onAddRandomnessUpdated={onAddRandomnessUpdated} />

                    <>
                        <br></br>
                        <button onClick={() => handleReset()}>Reset</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={() => handleEvaluate()}>Evaluate</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={handleClearResults}>Clear Results</button>
                        &nbsp;&nbsp;&nbsp;<button onClick={handleOpenModal}>Create Alert</button>
                        {algoName && algoName.length && shouldAllowEdits() ? <>&nbsp;&nbsp;&nbsp;<button onClick={openCreateAlgoModal}>Create Algo</button></> : null}
                    </>

                    <AlertTradeResultsChart showDrawdown={showDrawdown} trades={getTrades()} />

                    <br></br>
                    <br></br>
                    {performanceArray && performanceArray.length > 0 &&
                        <>
                            <ParameterSensitivityChart parameter={rangeParameter} showDrawdown={showDrawdown} performance={performance} performanceArray={performanceArray} />
                            <AlertPerformanceHistory mobileView={props.mobileView} performanceArray={performanceArray} onResultsSelected={(r) => { setPerformance(r); setConfig(r.config); }} />
                        </>
                    }
                    <QuoteDateAnalysis symbol={symbol} trades={performance.trades} />
                </>
                :
                null}

            <ActionResult result={result} />

            <CreateAlgoModal isOpen={createAlgoModalOpen} name={algoName} symbol={symbol} onClose={handleCreateAlgoClosed} mobileView={props.mobileView} />

            <Modal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalOpen}
                onClose={handleCloseModal}
            >
                <Box sx={modalStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Name?
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <input type="text" autoCorrect="off" onChange={(e) => setAlgoName(e.target.value)} />
                        <br></br>
                        <br></br>
                        {shouldAllowEdits() ? <button class="btn btn-primary" onClick={handleCreateAlert} type="button">Submit</button> : null}
                    </Typography>
                </Box>
            </Modal>

        </div >);
}

export default AlertSandbox;